import React, { useEffect, useRef, useState } from 'react';
import './servicesWonderaly.scss';
import DigitalizacionServices from './ourServices/digitalizacionServices';
import AutomatizacionServices from './ourServices/automatizacionServices';
import InteligenciaArtificialService from './ourServices/inteligenciaArtificialService';
import EstrategiaNegocioServices from './ourServices/estrategiaNegocioServices';
import BusinessIntelligenceService from './ourServices/businessIntelligenceService';
import {
  FaBrain,
  FaChartBar,
  FaChalkboardTeacher,
  FaBuilding,
  FaChartLine,
} from 'react-icons/fa';

const ServicesWonderaly = () => {
  const [activeService, setActiveService] = useState('consultoria');
  const lineRefs = useRef([]);

  const services = [
    {
      id: 'consultoria',
      label: 'Consultoría Neuropsicológica',
      icon: <FaBrain size={60} />,
      component: <DigitalizacionServices />,
    },
    {
      id: 'predictivo',
      label: 'Análisis Predictivo del Público',
      icon: <FaChartBar size={60} />,
      component: <InteligenciaArtificialService />,
    },
    {
      id: 'talleres',
      label: 'Talleres de Capacitación',
      icon: <FaChalkboardTeacher size={60} />,
      component: <BusinessIntelligenceService />,
    },
    {
      id: 'espacios',
      label: 'Optimización de Espacios Creativos',
      icon: <FaBuilding size={60} />,
      component: <AutomatizacionServices />,
    },
    {
      id: 'evaluacion',
      label: 'Evaluación y Mejora Continua con BI',
      icon: <FaChartLine size={60} />,
      component: <EstrategiaNegocioServices />,
    },
  ];

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 0px 0px',
    };

    const lineObservers = lineRefs.current.map((lineRef) => {
      if (!lineRef) return null;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('content__title-line--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      observer.observe(lineRef);
      return observer;
    });

    return () => {
      lineObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  const handleCardClick = (serviceId) => {
    setActiveService((prev) => (prev === serviceId ? null : serviceId));
  };

  return (
    <div className="services-wonderaly">
      <div className="services-wonderaly__header">
        <h2 className="services-wonderaly__title content__title-backgroundDark">
          Descubre cómo podemos transformar tu producción.
        </h2>
        <div
          ref={(el) => (lineRefs.current[0] = el)}
          className="content__title-line"
        />
      </div>

      <div className="services-wonderaly__grid">
        {services.map((service) => (
          <div key={service.id} onClick={() => handleCardClick(service.id)}>
            <div
              className={`services-wonderaly__card ${activeService === service.id ? 'services-wonderaly__card--active' : ''}`}
            >
              <div
                className={`services-wonderaly__icon-container ${activeService === service.id ? 'services-wonderaly__icon-container--active' : ''}`}
              >
                {service.icon}
              </div>
              <h3
                className={`services-wonderaly__label ${activeService === service.id ? 'services-wonderaly__label--active' : ''}`}
              >
                {service.label}
              </h3>
            </div>
            <div>
              {activeService === service.id && (
                <div className="services-wonderaly__service-content1100">
                  {service.component}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="services-wonderaly__content">
        <div className="services-wonderaly__service-content">
          {services.find((service) => service.id === activeService)?.component}
        </div>
      </div>
    </div>
  );
};

export default ServicesWonderaly;
